/* eslint-disable max-len */
/* eslint-disable implicit-arrow-linebreak */
import { FunctionComponent } from 'react';
import { Route } from 'react-router-dom';
import { AdminRouteName } from '../CONSTANTS';
import DashboardWrap from '../../components/DashboardWrap';
import AllBillsPayment from './AllBillsPayment';
import PendingBillsPayment from './PendingBillsPayment';
import SuccessfulBillsPayment from './SuccessfulBillsPayment';
import FailedBillsPayment from './FailedBillsPayment';
import './bills-payment.scss';

const BillsPayment: FunctionComponent = () =>

  (

    <DashboardWrap>
      <Route component={AllBillsPayment} exact path={AdminRouteName.billsPaymentRoute} />
      <Route component={PendingBillsPayment} path={AdminRouteName.pendingBillsPaymentRoute} />
      <Route component={SuccessfulBillsPayment} path={AdminRouteName.successfulBillsPaymentRoute} />
      <Route component={FailedBillsPayment} path={AdminRouteName.failedBillsPaymentRoute} />

    </DashboardWrap>

  );
export default BillsPayment;
